export function capitalize(value: string): string {
	if (!value) return "";
	return value.replace(/^\w/, c=> c.toUpperCase())
}